import React from 'react';
import './Footer.css';

function Footer() {
  const [emailVisible, setEmailVisible] = React.useState(false);

  const handleShowEmail = () => setEmailVisible(!emailVisible);

  return (
    <footer className='Footer'>
      <div className='Footer__email'>
        <button
          id='emailButton'
          onClick={handleShowEmail}
          className='Footer__email-button'
        >
          ✉️
        </button>
        <div className='Footer__email-address-container'>
          <span className={`Footer__email-address ${emailVisible ? 'Footer__email-address--show' : ''}`}>
            hello@whoisjaytee.com
          </span>
        </div>
      </div>
      <div className='Footer__copyright'>
        &copy; {new Date().getFullYear()}
      </div>
    </footer>
  );
}

export default Footer;
